import actionTypes from '../constants/actionTypes'

export default function utils(state = {}, action) {
  
  let breakPoint
  let isSmallDevice
  let currentWidth

  switch(action.type) {
    case actionTypes.SET_DEVICE_TYPE:
      
      currentWidth = action.currentWidth
      breakPoint = 768
      isSmallDevice = false

      if (currentWidth < breakPoint) {
        isSmallDevice = true
      }

      return Object.assign({}, state, {
        isSmallDevice
      })

    default:
      return state
  }
}



/** WEBPACK FOOTER **
 ** ../app/reducers/utils.js
 **/